import Http from '@/http';
import {
  IAccount,
  IAccountResponse,
  IAssessmentResult,
  IContractRecord,
  IDataAttachment,
  IEducationalExperience,
  IEmergencyContact,
  IFamilyMember,
  IGetUserConfigReply,
  IRosterOnJobCollectInfo,
  ISearchMemberResponse,
  ISearchRosterResponse,
  ISummary,
  IWorkExperience,
  IWorkInfo,
} from '@/api/typings/roster';
import { IMember } from '@/api/typings/common';
// import { AccountType } from '@/constants/business/people';
import { ISalaryInfo, ISkillCertificate } from '@/api/typings/entry';
interface ISearchRosterParams {
  key?: string; // 关键字搜索
  page?: number;
  size?: number;
  sort?: string;
  /** 是否返回家庭成员列表，默认 false */
  includeFamilyMember?: boolean;
  advanced: {
    /**
     * 合同期限类型
     */
    contractTermType?: number[];
    /**
     * 部门ids
     */
    departmentId?: number[];
    /**
     * 入职日期结束时间
     */
    entryDateEnd?: number;
    /**
     * 入职日期开始时间
     */
    entryDateStart?: number;
    /**
     * 学历
     */
    highestEducation?: number[];
    /**
     * 岗位
     */
    jobId?: number[];
    /**
     * 工号
     */
    jobNumber?: string;
    /**
     * 直属上级
     */
    leaderId?: number;
    /**
     * 专业
     */
    major?: string;
    /**
     * 职级
     */
    rankId?: number[];
    /**
     * 工资卡账号
     */
    salaryCardNumber?: string;
    /**
     * 员工状态
     */
    status?: number[];
    /**
     * 人员类型
     */
    type?: number[];
    /**
     * 工作地点
     */
    workPlace?: number[];
    /**
     * 参加工作结束时间
     */
    workStartDateEnd?: number;
    /**
     * 参加工作开始时间
     */
    workStartDateStart?: number;

    /**
     * 是否有工资卡
     */
    hasSalaryCard?: 1 | 2; // 1是 2否
  };
}

export enum RosterOnePageSalaryDisplayMode {
  Hidden = 1,
  Range = 2,
  Full = 3,
}

interface IExportRosterOnePageParams {
  accountId: number;
  includeAssessmentResult: boolean;
  includeRecruitmentRecord: boolean;
  includeSalaryInfo: boolean;
  includeOfferSalary: boolean;
  salaryDisplayMode: RosterOnePageSalaryDisplayMode;
}

export function apiSearchRoster(params: ISearchRosterParams) {
  return Http.post<ISearchRosterParams, ISearchRosterResponse>(
    '/hr/roster/search',
    params
  );
}
export function apiGetRosterSummary() {
  return Http.get<void, ISummary>('/hr/roster/summary');
}
export function apiGetRosterAccount(params: { id: number }) {
  return Http.get<{ id: number }, IAccountResponse>(
    '/hr/roster/get/account',
    params
  );
}
export function apiSearchMember(params: {
  key?: string;
  dataPermission?: boolean;
  includeResigned?: boolean;
  resignAfter?: number;
}) {
  return Http.get<{ key?: string }, ISearchMemberResponse>(
    '/hr/roster/retrieve',
    params
  );
}

/** 添加人员 */
interface IAddNewAccountParams {
  name?: string;
  phone?: string;
  dingName?: string;
  workInfo?: IWorkInfo;
  trialDate?: number;
  salaryInfo?: ISalaryInfo;
}
export function apiAddNewAccount(params: IAddNewAccountParams) {
  return Http.post<IAddNewAccountParams, void>(
    '/hr/roster/add/new_account',
    params
  );
}

/** 保存工作信息 */
export function apiSaveWorkInfo(params: { workInfo: IWorkInfo }) {
  return Http.post<{ workInfo: IWorkInfo }, void>(
    '/hr/roster/save/workinfo',
    params
  );
}
/** 保存个人信息 */
export function apiSaveAccountInfo(params: { account: IAccount }) {
  return Http.post<{ account: IAccount }, void>(
    '/hr/roster/save/accountinfo',
    params
  );
}
/** 保存教育经历信息 */

interface IEducationalExperienceParams {
  educationalExperience: IEducationalExperience[];
  accountId: number;
}
export function apiEducationalExperience(params: IEducationalExperienceParams) {
  return Http.post<IEducationalExperienceParams, void>(
    '/hr/roster/save/educational_experience',
    params
  );
}
/** 保存教育经历信息 */

interface IWorkExperienceParams {
  workExperience: IWorkExperience[];
  accountId: number;
}
export function apiSaveWorkExperience(params: IWorkExperienceParams) {
  return Http.post<IWorkExperienceParams, void>(
    '/hr/roster/save/work_experience',
    params
  );
}

/** 保存紧急联系人 */

interface IEmergencyContactParams {
  emergencyContact: IEmergencyContact[];
  accountId: number;
}
export function apiSaveEmergencyContact(params: IEmergencyContactParams) {
  return Http.post<IEmergencyContactParams, void>(
    '/hr/roster/save/emergency_contact',
    params
  );
}

/** 保存家庭成员 */

interface IFamilyMemberParams {
  familyMember: IFamilyMember[];
  accountId: number;
}
export function apiSaveFamilyMemberContact(params: IFamilyMemberParams) {
  return Http.post<IFamilyMemberParams, void>(
    '/hr/roster/save/family_member',
    params
  );
}

export function apiSaveSkillCertificate(params: {
  skillCertificate: ISkillCertificate[];
  accountId: number;
}) {
  return Http.post<{ skillCertificate: ISkillCertificate[] }, void>(
    '/hr/roster/save/skill_certificate',
    params
  );
}
/** 保存家庭成员 */

interface IFamilyMemberParams {
  familyMember: IFamilyMember[];
  accountId: number;
}
/** 保存合同记录 */
export function apiSaveContactRecord(params: {
  contractRecord?: IContractRecord;
}) {
  return Http.post<
    {
      contractRecord?: IContractRecord;
    },
    void
  >('/hr/roster/save/contract_record', params);
}

/** 花名册删除合同记录 */
export function apiDeleteContactRecord(params: { id?: number }) {
  return Http.post<{ id?: number }, void>(
    '/hr/roster/delete/contract_record',
    params
  );
}

/** 保存资料附件 */
export function apiSaveDataAttachment(params: {
  dataAttachment?: IDataAttachment;
}) {
  return Http.post<
    {
      dataAttachment?: IDataAttachment;
    },
    void
  >('/hr/roster/save/data_attachment', params);
}

/** 保存考核结果 */
export function apiSaveAssessmentResult(params: {
  assessmentResult?: IAssessmentResult;
}) {
  return Http.post<
    {
      assessmentResult?: IAssessmentResult;
    },
    void
  >('/hr/roster/save/assessment_result', params);
}

/** 删除考核结果 */
export function apiDeleteAssessmentResult(params: { id?: number }) {
  return Http.post<{ id?: number }, void>(
    '/hr/roster/delete/assessment_result',
    params
  );
}

/** 导出花名册 */
export function apiExportRoster(params: ISearchRosterParams) {
  return Http.post<ISearchRosterParams, Blob>(
    '/hr/roster/search/export',
    params,
    {
      responseType: 'blob',
    }
  );
}

/** 导出一页纸档案 */
export function apiExportRosterOnePage(params: IExportRosterOnePageParams) {
  return Http.post<IExportRosterOnePageParams, Blob>(
    '/hr/roster/export/one_page',
    params,
    {
      responseType: 'blob',
    }
  );
}
/** 获取负责人  */
export function apiGetLeader(params: { accountId: number }) {
  return Http.get<
    { accountId: number },
    {
      departmentManager?: IMember;
      perDeptLeader?: IMember;
      perManager?: IMember;
      companyEmail: string;
    }
  >('/hr/roster/get/leader', params);
}
/** 保存在职采集信息 */
export function apiSaveCollectInfo(params: {
  accountId?: number;
  collectInfo?: IRosterOnJobCollectInfo;
}) {
  return Http.post<
    {
      accountId?: number;
      collectInfo?: IRosterOnJobCollectInfo;
    },
    void
  >('/hr/roster/save/collect_info', params);
}
/** 导入花名册 */
export function apiImportRosterMember(data: FormData) {
  return Http.post<FormData, void>('/hr/roster/search/import', data);
}
export function apiGetMyAccount() {
  return Http.get<void, { account: IAccount; workInfo: IWorkInfo }>(
    '/hr/roster/get/my_account'
  );
}

export function apiGetUserConfig(params: { code: string }) {
  return Http.get<
    {
      code: string;
    },
    IGetUserConfigReply
  >('/hr/system/get_user_config', params);
}

export function apiSaveUserConfig(params: { config: string; code: string }) {
  return Http.post<{ config: string; code: string }, void>(
    '/hr/system/save_user_config',
    params
  );
}

/** 花名册批量保存资料附件 */
export function apiBatchSaveDataAttachment(params: {
  dataAttachmentList?: IDataAttachment[];
}) {
  return Http.post<{ dataAttachmentList?: IDataAttachment[] }, void>(
    '/hr/roster/batch_save/data_attachment',
    params
  );
}

/** 批量获取资料附件 */
export function apiBatchGetDataAttachment(params: { accountIds?: number[] }) {
  return Http.get<
    { accountIds?: number[] },
    { dataAttachmentList?: IDataAttachment[] }
  >('/hr/roster/batch_get/data_attachment', params);
}

export interface IEditRosterInfo {
  accountId?: number[];
  fieldName?: string;
  newValue?: string;
}

export function apiEditRosterInfo(params: IEditRosterInfo) {
  return Http.post<IEditRosterInfo, void>(
    '/hr/roster/field/dynamic_update',
    params
  );
}
